import { TmdxAvatar } from '@ds';
import { CaseResourceType } from '@/api/apis/case';

type ChangeLogResourcesProps = {
  type: CaseResourceType;
  title: string;
  photoPath?: string;
  isScs?: boolean;
};

export const ChangeLogResources = ({ type, title, photoPath, isScs }: ChangeLogResourcesProps) => {
  const deviceType = isScs ? 'scs' : 'device';
  const avatarType = type === CaseResourceType.OCSConsole ? deviceType : 'user';

  return (
    <div className="flex gap-1.5 items-center">
      <TmdxAvatar type={avatarType} size="sm" radius="full" name={title} src={photoPath} />
      <span className="text-s-r text-base-20">{title}</span>
    </div>
  );
};
